/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeatureTier } from './FeatureTier';
import {
    FeatureTierFromJSON,
    FeatureTierFromJSONTyped,
    FeatureTierToJSON,
} from './FeatureTier';

/**
 * 
 * @export
 * @interface CheckoutRequest
 */
export interface CheckoutRequest {
    /**
     * 
     * @type {FeatureTier}
     * @memberof CheckoutRequest
     */
    targetTier?: FeatureTier;
}

/**
 * Check if a given object implements the CheckoutRequest interface.
 */
export function instanceOfCheckoutRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckoutRequestFromJSON(json: any): CheckoutRequest {
    return CheckoutRequestFromJSONTyped(json, false);
}

export function CheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetTier': !exists(json, 'target_tier') ? undefined : FeatureTierFromJSON(json['target_tier']),
    };
}

export function CheckoutRequestToJSON(value?: CheckoutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_tier': FeatureTierToJSON(value.targetTier),
    };
}

